function id(x) {
  return x;
}

export { id };
/* No side effect */